export default __webpack_public_path__ + "assets/583d05e584b17cc6bf3818e8173df48b.jpg";